import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import axios from 'axios'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'
import News, { NewsRecord } from './models/News'
import User, { UserRecord } from './models/User'
import Team, { TeamProfile } from './models/Team'
import Questionnaire from './models/Questionnaire'
import QuestionCategory from './models/QuestionCategory'
import Question from './models/Question'
import pagination from './modules/pagination'
import user from './modules/user'
import news from './modules/news'
import breadcrumb from './modules/breadcrumb'
import dashboard from './modules/dashboard'
import modelExtensions from './models/extensions'

Vue.use(Vuex)

// Create a new instance of Database.
/**
 * @type {Database}
 */
const database = new VuexORM.Database()

// Register Models to Database.
database.register(News, {})
database.register(NewsRecord, modelExtensions)
database.register(UserRecord, {})
database.register(User, {})
database.register(Team, {})
database.register(TeamProfile, {})
database.register(Questionnaire, {})
database.register(QuestionCategory, {})
database.register(Question, {})

// Setup vuex-orm/plugin-axios
VuexORM.use(VuexORMAxios, {
  axios,
  baseURL: '/api',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

const plugins = []

// Add plugins
plugins.push(VuexORM.install(database))

export default new Vuex.Store({
  modules: {
    breadcrumb,
    dashboard,
    news,
    pagination,
    user
  },
  mutations: {
    SET_LOADING (state, payload) {
      state.loading = payload
    }
  },
  state: {
    loading: false
  },
  plugins: plugins
})
